import type { ShareContentGenerator } from './ShareManager';
import type { ShareContent, ShareOptions } from './Types';
import type { TelemetryEventQueue } from '@egr/xbox/telemetry/TelemetryEventQueue';

import bind from 'bind-decorator';

import { ShareFilenameManager } from './ShareFilenameManager';

export class ShareTask<AdditionalOptions extends object = {}> {
    public readonly itemIds: ReadonlyArray<string>;
    public isCanceled: boolean = false;
    public readonly shareFilenameManager: ShareFilenameManager;
    public readonly telemetryEventQueue?: TelemetryEventQueue;

    public constructor(
        private options: Readonly<ShareOptions & Partial<AdditionalOptions>>,
        private generators: ReadonlyArray<ShareContentGenerator>,
    ) {
        this.itemIds = options.itemIds;
        this.shareFilenameManager = new ShareFilenameManager({
            projectName: options.projectName,
            articleFilename: options.articleName,
            allowSubFolders: options.shareAsLink === true
        });
        this.telemetryEventQueue = options.telemetryEventQueue;
    }

    @bind
    public cancel(): void {
        this.isCanceled = true;
    }

    public async *getSharePayloads(): AsyncIterableIterator<ShareContent> {
        for (const generator of this.generators) {
            if (this.isCanceled) {
                break;
            }

            const matchingFormats = generator.formats?.filter(key => this.options.formats.has(key)) ?? Array.from(this.options.formats);
            if (matchingFormats.length) {
                try {
                    yield *generator.callback(this, matchingFormats);
                } catch (error) {
                    (
                        this.options.errorHandler ??
                        ((errorArg: Error) => {
                            throw errorArg;
                        })
                    )(error, matchingFormats);
                }
            }
        }
    }

    public getOptions(): Readonly<ShareOptions & Partial<AdditionalOptions>> {
        return this.options;
    }
}